import { useState } from 'react'
import { User, Building, Mail, CreditCard, Save, Bell, Shield, Globe } from 'lucide-react'
import { useAuth } from '../context/AuthContext'

export default function Settings() {
  const { user, company } = useAuth()
  const [activeTab, setActiveTab] = useState('profile')
  const [saving, setSaving] = useState(false)
  
  const [profileData, setProfileData] = useState({
    fullName: user?.full_name || '',
    email: user?.email || '',
    phone: user?.phone || '',
    role: user?.role || 'recruiter'
  })

  const [companyData, setCompanyData] = useState({
    name: company?.name || '',
    domain: company?.domain || '',
    logo: company?.logo_url || '',
    address: company?.address || ''
  })

  const tabs = [
    { id: 'profile', label: 'Mon Profil', icon: User },
    { id: 'company', label: 'Entreprise', icon: Building },
    { id: 'notifications', label: 'Notifications', icon: Bell },
    { id: 'security', label: 'Sécurité', icon: Shield },
    { id: 'subscription', label: 'Abonnement', icon: CreditCard }
  ]

  const handleSave = async () => {
    setSaving(true)
    try {
      await new Promise(resolve => setTimeout(resolve, 1500))
      console.log('Données sauvegardées:', { profileData, companyData })
    } catch (error) {
      console.error('Erreur sauvegarde:', error)
    } finally {
      setSaving(false)
    }
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case 'profile':
        return (
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-white mb-6">Informations Personnelles</h3>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Nom complet
                </label>
                <input
                  type="text"
                  value={profileData.fullName}
                  onChange={(e) => setProfileData({...profileData, fullName: e.target.value})}
                  className="w-full p-3 border border-gray-600 rounded-lg bg-gray-800/50 text-white focus:ring-2 focus:ring-blue-500"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Email professionnel
                </label>
                <input
                  type="email"
                  value={profileData.email}
                  onChange={(e) => setProfileData({...profileData, email: e.target.value})}
                  className="w-full p-3 border border-gray-600 rounded-lg bg-gray-800/50 text-white focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          </div>
        )

      case 'company':
        return (
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-white mb-6">Informations Entreprise</h3>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Nom de l'entreprise
                </label>
                <input
                  type="text"
                  value={companyData.name}
                  onChange={(e) => setCompanyData({...companyData, name: e.target.value})}
                  className="w-full p-3 border border-gray-600 rounded-lg bg-gray-800/50 text-white focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          </div>
        )

      default:
        return (
          <div className="text-center py-12">
            <h3 className="text-xl text-white mb-4">Section en développement</h3>
            <p className="text-gray-400">Cette fonctionnalité sera bientôt disponible.</p>
          </div>
        )
    }
  }

  return (
    <div className="min-h-screen p-4 md:p-8 pt-20">
      <div className="max-w-6xl mx-auto">
        
        <div className="mb-8">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-pink-400 to-blue-400 bg-clip-text text-transparent">
            Paramètres
          </h1>
          <p className="text-gray-400 mt-2">
            Configurez votre profil et les paramètres de votre compte
          </p>
        </div>

        <div className="grid lg:grid-cols-4 gap-8">
          
          {/* Navigation */}
          <div className="lg:col-span-1">
            <div className="glass-card p-0">
              <nav className="space-y-1">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`w-full flex items-center px-4 py-3 text-left rounded-lg transition-all ${
                      activeTab === tab.id
                        ? 'bg-gradient-to-r from-pink-500 to-blue-500 text-white'
                        : 'text-gray-300 hover:text-white hover:bg-white/10'
                    }`}
                  >
                    <tab.icon className="w-5 h-5 mr-3" />
                    {tab.label}
                  </button>
                ))}
              </nav>
            </div>
          </div>

          {/* Contenu */}
          <div className="lg:col-span-3">
            <div className="glass-card p-6">
              {renderTabContent()}
              
              <div className="flex justify-end pt-6 mt-6 border-t border-white/10">
                <button
                  onClick={handleSave}
                  disabled={saving}
                  className="flex items-center px-6 py-3 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-lg hover:from-pink-600 hover:to-blue-600 transition-all"
                >
                  <Save className="w-4 h-4 mr-2" />
                  {saving ? 'Sauvegarde...' : 'Sauvegarder'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}